import { render, staticRenderFns } from "./portfolio-grid.vue?vue&type=template&id=141c63c5&scoped=true&lang=pug"
import script from "./portfolio-grid.vue?vue&type=script&lang=ts"
export * from "./portfolio-grid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c63c5",
  null
  
)

export default component.exports